import React from "react";
import styles from "./Dashboard.module.scss";
import { FaLongArrowAltRight } from "react-icons/fa";

const StatsItem = ({
  title = "Пользователей за",
  date = "все время",
  count = "999+",
  link = "",
}) => {
  return (
    <div className={styles.dasboardStatsItem}>
      <h2>
        {title}
        <span> {date}</span>
      </h2>
      <div className={styles.dasboardStatsItemBottom}>
        <span>{count}</span>
        {link && (
          <a href={link}>
            Перейти к списку <FaLongArrowAltRight size={12} />
          </a>
        )}
      </div>
    </div>
  );
};

export default StatsItem;
